<script lang="ts">
  import { getAnswers } from '../../api/api'

  import { currentQuestion, surveyStatus } from '../../stores'

  let current = $surveyStatus.currentUserAnswer ? $surveyStatus.currentUserAnswer[0] : null
  let currentOpenAnswer = $surveyStatus.currentUserAnswer?.[0]?.openAnswerText
    ? $surveyStatus.currentUserAnswer[0].openAnswerText
    : null

  $: {
    $surveyStatus.currentUserAnswer = current ? [current] : []
    if ($surveyStatus.currentUserAnswer?.[0]?.isOpenAnswer)
      $surveyStatus.currentUserAnswer[0].openAnswerText = currentOpenAnswer
    $surveyStatus = $surveyStatus
  }
</script>

<svelte:window
  on:keydown={(event) => {
    if (event.key === 'ArrowRight' && event.altKey) {
      event.preventDefault()
      current = $currentQuestion.answers[0]
    }
  }}
/>

{#each $currentQuestion.answers as answer}
  <label>
    <input type="radio" bind:group={current} name="risposte" value={answer} />
    <div>
      {answer.text}
      {#if answer.isOpenAnswer && answer === current}
        <br />
        <div class="separator" />
        <input
          type="text"
          placeholder="Scrivi la tua risposta..."
          bind:value={currentOpenAnswer}
          maxlength="100"
        />
      {/if}
    </div>
  </label>
{/each}

<style>
  label {
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 1rem;
  }

  input[type='radio'] {
    -webkit-appearance: none;
    appearance: none;
    display: flex;
    background-color: black;
    margin: 0;
    font: inherit;
    width: 20px;
    height: 20px;
    border: 1px solid white;
    border-radius: 100%;
    transition: 120ms transform ease-in-out;
    justify-content: center;
    align-items: center;
  }

  input[type='radio']::before {
    content: '';
    flex: 0 0 auto;
    width: 13px;
    height: 13px;
    background-color: white;
    border-radius: 100%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
  }

  input[type='radio']:checked::before {
    transform: scale(1);
  }

  input[type='text'] {
    height: 25px;
    margin: 0;
    font-size: inherit;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid white;
    border-radius: 0;
    color: #7b7b7b;
  }
  input[type='text']:focus-visible {
    outline: 0;
  }
  .separator {
    height: 10px;
  }
</style>
